import { Env, Language, EnvConfig, LanguageConfig } from '@shopee-user/global';
import type { CollectionId } from '../types';

function getTimestampPath({
  language,
  env,
  collectionId,
  transifyMapping,
}: {
  language: Language;
  env: Env;
  collectionId: CollectionId;
  transifyMapping: Record<string, number>;
}): string {
  const computedEnv = env === 'live' ? 'live' : 'nonlive';
  const key = `${LanguageConfig[language].assetKey}-${computedEnv}-${collectionId}`;
  const timestamp = transifyMapping[key];
  return timestamp ? `.${timestamp}` : '';
}

export async function fetchTranslation({
  language,
  env,
  collectionId,
  transifyMapping = {},
}: {
  language: Language;
  env: Env;
  collectionId: CollectionId;
  transifyMapping?: Record<string, number>;
}): Promise<Record<string, string>> {
  const timestamp = getTimestampPath({
    transifyMapping,
    language,
    env,
    collectionId,
  });

  const filePath = `${EnvConfig[env].translationBaseUrl}${LanguageConfig[language].languageBaseUrl}.col${collectionId}${timestamp}.json`;
  const response = await fetch(filePath);
  if (response.status >= 200 && response.status < 300) {
    return (await response.json()) as Record<string, string>;
  } else {
    return {};
  }
}
